import {DraftError} from './DraftError.js'

export class PublishDraftError extends DraftError {}
